import { render, staticRenderFns } from "./klaviyo.vue?vue&type=template&id=79dfe2d0&scoped=true&"
import script from "./klaviyo.vue?vue&type=script&lang=js&"
export * from "./klaviyo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dfe2d0",
  null
  
)

export default component.exports